export * from './agreements.js';
export * from './demographics.js';
export * from './income.js';

export const utilityTypes = [
  { label: 'Electricity', value: 'electricity' },
  { label: 'Gas', value: 'gas' },
  { label: 'Water/Sewage', value: 'waterOrSewage' },
  { label: 'Oil', value: 'oil' },
  { label: 'Propane', value: 'propane' },
  { label: 'Trash', value: 'trash' },
  { label: 'Wood', value: 'wood' },
  { label: 'Other', value: 'other' },
];

export const YesNoOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const RadioButtonOptions = {
  // @deprecated do not use this in an application! Use YesNoOptions instead
  YesOrNo: [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ],
  TrueOrFalse: [
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' },
  ],
  YesNoUnsure: [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
    { label: 'Unsure', value: 'unsure' },
  ],
};

export const AgreementOptions = [
  { value: 'strongly-agree', label: 'Strongly agree' },
  { value: 'agree', label: 'Agree' },
  { value: 'disagree', label: 'Disagree' },
  { value: 'strongly-disagree', label: 'Strongly disagree' },
];

export const ConfidentOptions = [
  { value: 'extremely-confident', label: 'Extremely Confident' },
  { value: 'confident', label: 'Confident' },
  { value: 'not-confident', label: 'Not confident' },
  { value: 'not-at-all-confident', label: 'Not at all confident' },
];

export const SatisfiedOptions = [
  { value: 'extremely-satisfied', label: 'Extremely Satisfied' },
  { value: 'satisfied', label: 'Satisfied' },
  { value: 'not-satisfied', label: 'Somewhat satisfied' },
  { value: 'not-at-all-satisfied', label: 'Not at all satisfied' },
];

export const LikelyOptions = [
  { value: 'extremely-likely', label: 'Extremely Likely' },
  { value: 'likely', label: 'Likely' },
  { value: 'not-likely', label: 'Somewhat likely' },
  { value: 'not-at-all-likely', label: 'Not at all likely' },
];
